import { icons } from 'lucide-react'

export type IconName = keyof typeof icons | string

type Props = {
  name: IconName
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
}

const toComponentKey = (name: string) =>
  name
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('')

export function Icon({ name, size = 16, color, strokeWidth = 2, className }: Props) {
  const Cmp = (icons as Record<string, typeof icons[keyof typeof icons] | undefined>)[
    toComponentKey(String(name))
  ]
  if (!Cmp) return null
  return (
    <Cmp
      width={size}
      height={size}
      color={color}
      strokeWidth={strokeWidth}
      className={['lucide', className].filter(Boolean).join(' ')}
      aria-hidden
    />
  )
}
